// import {Link} from 'react-router-dom'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook, faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons"

const FooterLayout = () => {
    return ( 
      <>
          <footer class="p-2 mt-5" style={{backgroundColor: "#00a7ac",marginTop:250}}>
  <ul class="justify-content-between footer-flex">
    <li class="mt-3 text-white" style={{fontSize:18}}>Copyright © 2025 KnackHire All Rights Reserved</li>
    <li class="mt-2"><a
        class="btn btn-link btn-floating btn-lg text-white"
        href="https://www.facebook.com/knackhook/" target="blank"
        role="button"
        data-mdb-ripple-color="dark"
        ><FontAwesomeIcon icon={faFacebook} />
          {/* <i class="fa fa-facebook-f"></i
      > */}
    </a>

     
      <a
        class="btn btn-link btn-floating btn-lg text-white"

        href="https://www.linkedin.com/company/knackhook/mycompany/"  target="blank"
        role="button"
        data-mdb-ripple-color="dark"
        ><FontAwesomeIcon icon={faLinkedin} /></a>
      <a
      class="btn btn-link btn-floating btn-lg  text-white"  target="blank"
      href="https://twitter.com/Knack_Hook"
      role="button"
      data-mdb-ripple-color="dark"
      ><FontAwesomeIcon icon={faTwitter} /></a>
</li>

  </ul>
   
    </footer>
   
    </>
     );
}
export default FooterLayout;